import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { DynamicFormsModule } from '../../dynamic-forms/dynamic-forms.module';
import { MyAccountPermissionsAuthGuard } from '../guards/myaccount-permissions-auth.guard';
import { MyaccountEmployeeAddressModule } from '../myaccount-employee-address/myaccount-employee-address.module';
import { MyaccountPermissionsModule } from '../myaccount-permissions/myaccount-permissions.module';
import { EditEmployeeComponent } from './edit-employee.component';

@NgModule({
  declarations: [EditEmployeeComponent],
  imports: [
    CommonModule,
    DynamicFormsModule,
    I18nModule,
    RouterModule,
    UrlModule,
    MyaccountPermissionsModule,
    MyaccountEmployeeAddressModule,
    ConfigModule.withConfig({
      cmsComponents: {
        EditEmployeeComponent: {
          component: EditEmployeeComponent,
          // deferLoading: DeferLoadingStrategy.DEFER,
          guards: [MyAccountPermissionsAuthGuard],
        },
      },
    } as CmsConfig),
  ],
})
export class EditEmployeeModule {}
